import Link from "next/link";
export default function CatDis(props) {
  return (
    <div className="dis-container">
      <div className="thumb-dis">
        <div>
          <div className="dis">
            <div className="contant para description" dangerouslySetInnerHTML={{ __html:props.dis}}/>
          </div>
        </div>
      </div>
    </div>
  );
}
